import src from "IMAGE";
export default { src, width: 393, height: 786, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAQUlEQVR42mWNNxIAIAgE/f87TRgrbDEgjqPFFbsMd6rVQHfUL4pnKEAtuy0kFeYLEEa9rpgMCwHMdogBS56OZ6UDRsF5cIoXXGQAAAAASUVORK5CYII="};
